export default "__VITE_ASSET__CbfOynPm__"